import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Download, Loader2, Map as MapIcon, Check } from 'lucide-react';
import { roadsMeta, loadRoads, areaOf, projPts, covers } from '../lib/offRoute';

// project header: store the road network of the project area for the offline navigation (before driving into a dead zone)
export default function RoadPrefetch({ t, project }) {
  const [meta, setMeta] = useState(undefined), [busy, setBusy] = useState(false);
  const pts = projPts(project);
  useEffect(() => {
    roadsMeta(project.id).then(setMeta);
    const on = (e) => e.detail === project.id && roadsMeta(project.id).then(setMeta);
    window.addEventListener('giss-roads-saved', on);
    return () => window.removeEventListener('giss-roads-saved', on);
  }, [project.id]);
  if (meta === undefined || !(project.fittings || []).length) return null;
  const ok = !!meta && covers(meta, pts);
  const load = async () => {
    setBusy(true);
    try { await loadRoads(project.id, areaOf(pts)); toast.success(t.onLoaded); } catch (e) { toast.error(`${t.onLoadErr} (${e.message})`); }
    setBusy(false);
  };
  return (
    <div className={`road-pre ${ok ? 'ok' : 'todo'}`} data-testid="road-prefetch">
      {ok ? <Check size={15} /> : <MapIcon size={15} />}
      <small data-testid="road-prefetch-state">{ok ? t.onRoads.replace('{km}', meta.km).replace('{d}', new Date(meta.at).toLocaleDateString(t.locale)) : meta ? t.rpPartial : t.rpHint}</small>
      <button className={`btn btn-sm ${ok ? 'btn-outline' : 'btn-dark'}`} data-testid="road-prefetch-btn" disabled={busy || !navigator.onLine} title={navigator.onLine ? '' : t.rpOffline} onClick={load}>
        {busy ? <Loader2 size={14} className="spin" /> : <Download size={14} />} {busy ? t.rpBusy : ok ? t.onReload : t.rpBtn}
      </button>
    </div>
  );
}
